import {Component, OnInit} from '@angular/core';

@Component({
    templateUrl: './data-export.component.html',
    styleUrls: ['./data-export.component.scss']
})
export class DataExportComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
